export default __webpack_public_path__ + "static/media/io.38ae2f09.gif";